import React from 'react'
import qs from 'qs'
import { throttle } from 'lodash'
import { SearchNormal1 } from 'iconsax-react'
import { useHistory, useLocation } from 'react-router'
import { useTheme } from '@mui/material'

import MobileAgentPage from '../../../../components/templates/MobileAgentPage'
import MobileAgentPageTitle from '../MobileAgentPageTitle'
import MobileQueue from '../MobileQueue'
import MobileConversation from '../MobileConversation'
import MobileEngagementHub from '../MobileEngagementHub'
import MobileFilterModal from '../../../../components/organisms/ConversationsV2/FiltersV2/MobileModal'
import MergeContactModal from '../../../../components/molecules/MergeContactModal'

import { useAppDispatch, useAppSelector } from '../../../../hooks/redux'
import {
  loadNewConversationsList,
  MobileScreen,
  selectConvo,
  setConversation,
  setInbox,
  setMobileScreen,
  setTopFilter
} from '../../../../slices/convo'
import { useEnvironment } from '../../../../providers/EnvironmentProvider'
import { useQueueState } from '../../../../providers/QueueStateProvider'
import { getSession, updateSession } from '../../../../lib/api'
import { formatUpdateSession } from '../../../../components/organisms/Conversations/helpers'
import { useSocket } from '../../../../providers/SocketProvider'
import { useAgent } from '../../../../providers/AgentProvider'
import { Routes } from '../../../../Routes'

import { selectAccess } from '../../../../slices/accessSlice'
import { canPullTimeline, CAN_PULL_RESULT } from '../../helpers'
import useAccess from '../../../../hooks/useAccess'
import { useChatScroll } from '../../../../providers/ChatScrollProvider'
import useStyles from './styles'

const FilterIcon: React.FC<React.HTMLAttributes<SVGSVGElement>> = props => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M3 4.25C2.58579 4.25 2.25 4.58579 2.25 5C2.25 5.41421 2.58579 5.75 3 5.75V4.25ZM3 11.25C2.58579 11.25 2.25 11.5858 2.25 12C2.25 12.4142 2.58579 12.75 3 12.75V11.25ZM12 12.75C12.4142 12.75 12.75 12.4142 12.75 12C12.75 11.5858 12.4142 11.25 12 11.25V12.75ZM21 12.75C21.4142 12.75 21.75 12.4142 21.75 12C21.75 11.5858 21.4142 11.25 21 11.25V12.75ZM21 5.75C21.4142 5.75 21.75 5.41421 21.75 5C21.75 4.58579 21.4142 4.25 21 4.25V5.75ZM12 18.25C11.5858 18.25 11.25 18.5858 11.25 19C11.25 19.4142 11.5858 19.75 12 19.75V18.25ZM21 19.75C21.4142 19.75 21.75 19.4142 21.75 19C21.75 18.5858 21.4142 18.25 21 18.25V19.75ZM3 18.25C2.58579 18.25 2.25 18.5858 2.25 19C2.25 19.4142 2.58579 19.75 3 19.75V18.25ZM3 5.75H10V4.25H3V5.75ZM3 12.75H12V11.25H3V12.75ZM19 12.75H21V11.25H19V12.75ZM14 5.75H21V4.25H14V5.75ZM12 19.75H21V18.25H12V19.75ZM3 19.75H5V18.25H3V19.75ZM8.25 19C8.25 19.6904 7.69036 20.25 7 20.25V21.75C8.51878 21.75 9.75 20.5188 9.75 19H8.25ZM7 20.25C6.30964 20.25 5.75 19.6904 5.75 19H4.25C4.25 20.5188 5.48122 21.75 7 21.75V20.25ZM5.75 19C5.75 18.3096 6.30964 17.75 7 17.75V16.25C5.48122 16.25 4.25 17.4812 4.25 19H5.75ZM7 17.75C7.69036 17.75 8.25 18.3096 8.25 19H9.75C9.75 17.4812 8.51878 16.25 7 16.25V17.75ZM18.25 12C18.25 12.6904 17.6904 13.25 17 13.25V14.75C18.5188 14.75 19.75 13.5188 19.75 12H18.25ZM17 13.25C16.3096 13.25 15.75 12.6904 15.75 12H14.25C14.25 13.5188 15.4812 14.75 17 14.75V13.25ZM15.75 12C15.75 11.3096 16.3096 10.75 17 10.75V9.25C15.4812 9.25 14.25 10.4812 14.25 12H15.75ZM17 10.75C17.6904 10.75 18.25 11.3096 18.25 12H19.75C19.75 10.4812 18.5188 9.25 17 9.25V10.75ZM13.25 5C13.25 5.69036 12.6904 6.25 12 6.25V7.75C13.5188 7.75 14.75 6.51878 14.75 5H13.25ZM12 6.25C11.3096 6.25 10.75 5.69036 10.75 5H9.25C9.25 6.51878 10.4812 7.75 12 7.75V6.25ZM10.75 5C10.75 4.30964 11.3096 3.75 12 3.75V2.25C10.4812 2.25 9.25 3.48122 9.25 5H10.75ZM12 3.75C12.6904 3.75 13.25 4.30964 13.25 5H14.75C14.75 3.48122 13.5188 2.25 12 2.25V3.75Z'
      fill='#28303F'
    />
  </svg>
)

export interface MobileClientChatProps {}

const MobileClientChat: React.FC<MobileClientChatProps> = () => {
  const dispatch = useAppDispatch()
  const location = useLocation()
  const history = useHistory()
  const theme = useTheme()

  const hasPermission = useAccess()
  const params = qs.parse(location.search, { ignoreQueryPrefix: true })

  const [loaded, setLoaded] = React.useState(false)
  const [showFilter, setShowFilter] = React.useState(false)
  const [done, setDone] = React.useState(false)
  const [showMergeModal, setShowMergeModal] = React.useState(false)
  const [joined, setJoined] = React.useState(true)
  const [fetching, setFetching] = React.useState([])
  const { mobileScreen } = useAppSelector(selectConvo)
  const { loaded: accessLoaded } = useAppSelector(selectAccess)
  const { user, loaded: envLoaded } = useEnvironment()
  const { scrollToBottom, quickScrollToBottom } = useChatScroll()

  const {
    conversation,
    id: selectedConversation,
    resetSelected,
    setAccepted,
    handleSelect: handleConvoSelect
  } = useQueueState()
  const { session: querySessionId } = params

  const {
    topFilter,
    inbox,
    view,
    dataFetched,
    allConversations,
    allConversationsLoaded
  } = useAppSelector(selectConvo)

  const {
    api: { formatConversation, finishFetch, fetchTimeline, fetchSingleSession }
  } = useSocket()

  const { joinSession } = useAgent()

  const handleFilterClick = React.useCallback(() => {
    setShowFilter(true)
  }, [])
  const handleHideFilerModal = React.useCallback(() => setShowFilter(false), [])

  const openMergeModal = React.useCallback(() => {
    setShowMergeModal(true)
  }, [])

  const hideMergeModal = React.useCallback(() => {
    setShowMergeModal(false)
  }, [])

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const joinConversation = React.useCallback(
    throttle(
      async (sessionID: string) => {
        sessionStorage.setItem('viewing', sessionID)

        // Update query params so this doesn't happen again
        const newParams = { ...params }
        delete newParams.session
        history.replace(
          `${Routes.CLIENT_CHATS}${qs.stringify(newParams, {
            encode: false,
            addQueryPrefix: true
          })}`
        )
        setJoined(true)

        // Update inbox if needed
        if (['Transfers', 'Offline'].includes(topFilter)) {
          dispatch(setTopFilter('Assigned to me'))
        }

        // Switch to correct inbox
        let initialSession: LocalSession | APISession =
          allConversations[sessionID]
        if (!initialSession) {
          initialSession = await getSession(sessionID)
        }
        if (initialSession?.inbox_id !== inbox) {
          dispatch(setInbox(initialSession?.inbox_id))
        }

        // Update stored conversation
        const newConversation = formatConversation(initialSession, false)
        dispatch(
          setConversation({ id: sessionID, conversation: newConversation })
        )

        // Perform join and accept
        setAccepted(true)
        await joinSession(sessionID)
        handleConvoSelect(sessionID)

        // Update session ownership
        const addAssignedTo = formatUpdateSession(
          initialSession,
          Boolean(initialSession.ended_at)
        )
        addAssignedTo.assigned_to = user?.id
        // @ts-ignore
        await updateSession(sessionID, addAssignedTo)
        dispatch(setMobileScreen(MobileScreen.Conversation))
      },
      1000,
      { leading: false }
    ),
    [
      dispatch,
      allConversations,
      handleConvoSelect,
      history,
      setAccepted,
      formatConversation,
      joinSession,
      user,
      inbox,
      topFilter
    ]
  )

  // Trigger join when url id changes
  React.useEffect(() => {
    if (querySessionId) {
      setJoined(false)
    }
  }, [querySessionId])

  // Gets conversations when switching
  React.useEffect(() => {
    setDone(false)
    resetSelected()
  }, [topFilter, inbox, view, resetSelected])

  // Load list of sessions that match criteria
  React.useEffect(() => {
    if (user && !done && allConversationsLoaded) {
      dispatch(loadNewConversationsList(user.id))
      setLoaded(false)
    }
  }, [topFilter, inbox, view, user, dispatch, done, allConversationsLoaded])

  // Just display fetched conversations for now
  React.useEffect(() => {
    if (dataFetched && allConversationsLoaded) {
      setLoaded(true)
      setDone(true)
    }
  }, [loaded, dataFetched, allConversationsLoaded])

  // Selects the conversation from url / notification
  React.useEffect(() => {
    if (!allConversationsLoaded) {
      return
    }

    if (!querySessionId) {
      return
    }

    if (joined) {
      return
    }

    joinConversation(querySessionId as string)

    return () => {
      joinConversation.cancel()
    }
  }, [
    allConversations,
    querySessionId,
    allConversationsLoaded,
    params,
    joined,
    dispatch,
    joinConversation
  ])

  // Fetches conversation on first selecting
  React.useEffect(() => {
    if (!accessLoaded || !envLoaded) {
      return
    }

    if (!conversation) {
      return
    }

    if (fetching.includes(selectedConversation)) {
      return
    }

    if (!conversation.fetched) {
      const selectedID = selectedConversation
      const result = canPullTimeline(hasPermission, conversation, user)

      const onComplete = () => {
        setFetching(old => old.filter(id => id !== selectedID))
        finishFetch(selectedID, false)
        scrollToBottom()
        quickScrollToBottom()
      }

      if ([CAN_PULL_RESULT.FULL, CAN_PULL_RESULT.SESSION].includes(result)) {
        setFetching(old => [...new Set([...old, selectedID])])

        if (result === CAN_PULL_RESULT.FULL) {
          fetchTimeline(selectedID, false, false).then(onComplete)
        } else {
          fetchSingleSession(selectedID).then(onComplete)
        }
      } else {
        onComplete()
      }
    }
  }, [
    selectedConversation,
    conversation,
    fetching,
    finishFetch,
    fetchTimeline,
    fetchSingleSession,
    hasPermission,
    scrollToBottom,
    quickScrollToBottom,
    accessLoaded,
    envLoaded,
    user
  ])

  const classes = useStyles()

  return (
    <MobileAgentPage>
      {mobileScreen === MobileScreen.Queue && (
        <MobileAgentPageTitle title='Conversations'>
          <div className={classes.title}>
            <SearchNormal1 variant='Linear' size={theme.size.xl} />

            <FilterIcon onClick={handleFilterClick} />
          </div>
        </MobileAgentPageTitle>
      )}

      {mobileScreen === MobileScreen.Queue ? (
        <MobileQueue loaded={loaded} />
      ) : mobileScreen === MobileScreen.Conversation ? (
        <MobileConversation />
      ) : (
        <MobileEngagementHub openMergeModal={openMergeModal} />
      )}
      {showFilter && <MobileFilterModal onClose={handleHideFilerModal} />}

      {showMergeModal && <MergeContactModal onClose={hideMergeModal} />}
    </MobileAgentPage>
  )
}

export default MobileClientChat
